import React from 'react';
import { IMG_MAINTAIN } from '@assets';
import styled from 'styled-components';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { PUBLIC_ROUTE } from '@router/route.constants';

const Container = styled.div`
height: calc(100vh - 145px);
padding: 0 16px;
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;

.ant-btn {
    width: 170px !important;
}
`;

const Title = styled.div`
padding: 24px 0 10px;
font-size: 18px;
font-style: normal;
font-weight: 700;
line-height: normal;
color: #C21C05;
`;

const Text = styled.div`
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 1.5;
color: #808080;
`;

const TextBold = styled.div`
color: ${props => props.theme.primaryColor};
font-weight: 500;
font-size: 14px;
line-height: 1.5;
`;

const Image = styled.img.attrs({
    alt: 'img',
    src: IMG_MAINTAIN,
})`

`;

const Wrapper = styled.div`
margin-bottom: 24px;
text-align: center;
`;

const dateFormat = 'DD MMM YYYY, hh:mm A';

const MaintainCard = ({
    maintain_start,
    maintain_end,
}) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const currentTime = moment().unix();
    const dateToShow = currentTime >= maintain_end ? currentTime : maintain_end;

    const handleClicked = () => {
        navigate(`/${PUBLIC_ROUTE.HOME}/${PUBLIC_ROUTE.GAMES}`);
    }

    return (
        <Container>
            <Image />
            <Title>{t("maintain.maintainTitle")}</Title>
            <Text>{t("maintain.maintainSubtitle1")}</Text>
            <Text>{t("maintain.maintainSubtitle2")}</Text><br />
            <Wrapper>
                {maintain_start &&
                    <TextBold>
                        {t("maintain.maintainStart", {
                            maintain_start: moment.unix(maintain_start).format(dateFormat)
                        })}
                    </TextBold>
                }
                {maintain_end &&
                    <TextBold>
                        {t("maintain.maintainEnd", {
                            maintain_end: moment.unix(dateToShow).format(dateFormat)
                        })}
                    </TextBold>
                }
            </Wrapper>
            <Button
                type='primary'
                size='large'
                onClick={handleClicked}
            >
                {t("common.ok")}
            </Button>
        </Container>
    );
}

export default MaintainCard;